import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'crearArregloDeViajes'
})
export class GenearArregloDeViajes implements PipeTransform { 
    constructor(){}
//Convierte un objeto de puntos intermedios en un arreglo.
    transform(tamañoDeArreglo:number) {
        let arreglo=[]
        if(tamañoDeArreglo){
            for (let index = 0; index < tamañoDeArreglo; index++) {
                arreglo.push(index)
            }
        }
      return arreglo
    }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/generar-arreglo-de-viajes.pipe.ts